import i18n from "../i18n";

/**
 * Region subtag of the phone's locale (e.g. "GB"), if it carries a
 * well-formed one.
 */
export function phoneRegion(): string | undefined {
    const deviceLocale = navigator.language || navigator.languages?.[0];
    try {
        return deviceLocale ? new Intl.Locale(deviceLocale).region : undefined;
    } catch {
        // Malformed device locale; callers fall back to the bare language.
        return undefined;
    }
}

/**
 * Locale candidates for Intl date/number formatting.
 *
 * Formatting follows the language the user selected in the app, carrying the
 * device's region so regional conventions survive: a German speaker sees
 * 16:40 wherever they are, while English follows the device — 16:40 in the
 * UK, 4:40 PM in the US. Bare language tags alone would silently apply
 * en-US conventions to UK users, which is why the region is grafted on.
 */
export function formattingLocales(): string[] {
    const language = (i18n.resolvedLanguage ?? i18n.language ?? "en").split("-")[0];
    const region = phoneRegion();

    return region ? [`${language}-${region}`, language] : [language];
}
